var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganisation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1431 6.85798V2.57227L6.85742 2.57227L6.85742 9.42941",
    stroke: "white",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2852 21.4277H13.7137",
    stroke: "white",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2866 12L2.57227 12L2.57227 21.4286H10.2866L10.2866 12Z",
    stroke: "white",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4291 9.42773L13.7148 9.42773L13.7148 21.4277H21.4291L21.4291 9.42773Z",
    stroke: "white",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1426 12.8574H17.9997",
    stroke: "white",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1426 15.4277H17.9997",
    stroke: "white",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1426 18H17.9997",
    stroke: "white",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H6.85714",
    stroke: "white",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.4277H6.85714",
    stroke: "white",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisation);
export default __webpack_public_path__ + "static/media/organisation.0fc7d66045389247b9dbccb0c6e6fc6b.svg";
export { ForwardRef as ReactComponent };